import { useSetRecoilState } from "recoil"
import { styled } from "styled-components"
import signupStepState from "../../../recoil/signupStep/atom"
import { toast } from "react-toastify"
import { useFormContext } from "react-hook-form"
import { StyledButton } from "../../common/Buttons"
import FirstNameInput from "./FirstNameInput"
import LastNameInput from "./LastNameInput"
import EmailInputBox from "./EmailInputBox"
import PasswordInput from "./PasswordInput"
import PasswordConfirmInput from "./PasswordConfirmInput"

const SignupFormStep1 = () => {
  const setSignupStep = useSetRecoilState(signupStepState)

  const { trigger } = useFormContext()

  const goToNextStep = () => {
    trigger(
      [
        "firstName",
        "lastName",
        "email",
        "isEmailValid",
        "password",
        "passwordConfirm",
      ],
      { shouldFocus: true }
    ).then((isValidated) => {
      if (isValidated) {
        setSignupStep(2)
      } else {
        toast.error("가입 정보를 정확히 입력해주세요.")
      }
    })
  }

  return (
    <>
      <InputBox>
        <FirstNameInput />
        <LastNameInput />
        <EmailInputBox />
        <PasswordInput />
        <PasswordConfirmInput />
      </InputBox>
      <StyledButton $size="large" onClick={goToNextStep}>
        다음
      </StyledButton>
    </>
  )
}

export default SignupFormStep1

const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`
